<article class="aktive-sitzungen">
  <to-section-title
    [title]="'aktiveSitzungen.titel' | translate"
    [subtitle]="'aktiveSitzungen.untertitel' | translate"
  />

  @switch (zustand()) {
    @case ('laden') {
      <p class="aktive-sitzungen__laden" role="status">{{ 'aktiveSitzungen.laden' | translate }}</p>
    }
    @case ('fehler') {
      <div class="aktive-sitzungen__ladefehler" role="alert">
        <p class="aktive-sitzungen__ladefehler-text">{{ 'aktiveSitzungen.ladefehler' | translate }}</p>
        <button type="button" mat-stroked-button data-testid="profil-sitzungen-erneut" (click)="laden()">
          {{ 'common.retry' | translate }}
        </button>
      </div>
    }
    @default {
      <ul class="aktive-sitzungen__liste" role="list">
        @for (sitzung of sitzungen(); track sitzung.id) {
          <li class="aktive-sitzungen__zeile" [class.aktive-sitzungen__zeile--aktuell]="sitzung.aktuell">
            <span class="aktive-sitzungen__icon">
              <mat-icon aria-hidden="true">{{ icon(sitzung) }}</mat-icon>
            </span>
            <div class="aktive-sitzungen__text">
              <div class="aktive-sitzungen__kopf">
                <span class="aktive-sitzungen__geraet">{{ geraetName(sitzung) }}</span>
                @if (sitzung.aktuell) {
                  <app-status-pill kind="aktiv" size="sm" [label]="'aktiveSitzungen.dieseSitzung' | translate" />
                }
              </div>
              <div class="aktive-sitzungen__zeit">{{ relativeZeit(sitzung.zuletztAktiv) }}</div>
            </div>
            @if (!sitzung.aktuell) {
              <button
                type="button"
                class="aktive-sitzungen__abmelden"
                data-testid="profil-sitzung-abmelden"
                [attr.aria-label]="'aktiveSitzungen.abmeldenAria' | translate: { geraet: geraetName(sitzung) }"
                [disabled]="abmeldend() === sitzung.id"
                (click)="abmelden(sitzung)"
              >
                {{ 'aktiveSitzungen.abmelden' | translate }}
              </button>
            }
          </li>
        }
      </ul>
    }
  }
</article>
